export default {
    cta: "Ask An<br/>Advisor",
    ordered: "Ordered on {date}"
}